




























































import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
  import { Action, Getter, Mutation } from 'vuex-class';
  import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
  import {
    EMPLOYEE_EMAIL,
    GET_EMPLOYEE_EMAIL,
    OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
    OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS,
    RESET_PASSWORD,
    RESET_PASSWORD_LOADING,
    SEARCH_EMPLOYEES_CURRENT_FORM,
    SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
    SET_RESET_PASSWORD_LOADING,
    SET_SEARCH_EMPLOYEES_CURRENT_FORM,
  } from '@/types/managerForm.types';
  import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';

  @Component({})
  export default class FormResetPasswordModal extends Vue {

    @Inject() public $validator;

    @Action(GET_EMPLOYEE_EMAIL, StoreNamespace.MANAGER) public getEmployeeEmail;
    @Action(RESET_PASSWORD, StoreNamespace.MANAGER) public formResetPassword;

    @Mutation(SET_SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER) public setSearchEmployeesCurrentForm;
    @Mutation(SET_OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL, StoreNamespace.MANAGER)
    public setOpenManagerFormResetPasswordModal;
    @Mutation(SET_RESET_PASSWORD_LOADING, StoreNamespace.MANAGER) public setResetPasswordLoading;

    @Getter(EMPLOYEE_EMAIL, StoreNamespace.MANAGER) public employeeEmail!: string;
    @Getter(SEARCH_EMPLOYEES_CURRENT_FORM, StoreNamespace.MANAGER)
    public searchEmployeesCurrentForm!: ManagerForm101Data;
    @Getter(OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL, StoreNamespace.MANAGER)
    public openManagerFormResetPasswordModal!: boolean;
    @Getter(OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS, StoreNamespace.MANAGER)
    public openManagerFormResetPasswordModalErrors!: string[];
    @Getter(RESET_PASSWORD_LOADING, StoreNamespace.MANAGER) public resetPasswordLoading!: string;

    private currentEmployeeEmail = '';

    public created() {
      this.getEmployeeEmail({
        officeNum: this.searchEmployeesCurrentForm.officeNum,
        idNum: this.searchEmployeesCurrentForm.idNum,
        positionNum: this.searchEmployeesCurrentForm.positionNum,
      });
    }

    public mounted() {
      this.currentEmployeeEmail = this.employeeEmail;
    }

    public closeDialog(): void {
      this.setOpenManagerFormResetPasswordModal(false);
    }

    public onResetPassword(): void {
      this.setResetPasswordLoading(true);
      this.$validator.validateAll('resetPasswordForm').then((result: any) => {
        if (!result) {
          this.setResetPasswordLoading(false);
          setTimeout(() => {
            const firstInput: HTMLElement = document.querySelectorAll('label.is-error')[0] as HTMLElement;
            if (firstInput) {
              firstInput.focus();
            }
          });
        } else {
          this.formResetPassword({
            email: this.currentEmployeeEmail,
            officeNum: this.searchEmployeesCurrentForm.officeNum,
            idNum: this.searchEmployeesCurrentForm.idNum,
            positionNum: this.searchEmployeesCurrentForm.positionNum,
          });
        }
      });
    }

    public destroyed() {
      this.setOpenManagerFormResetPasswordModal(false);
    }

    @Watch('employeeEmail')
    public onEmployeeEmailChanged(newVal: string) {
      this.currentEmployeeEmail = newVal
    }

  }
